import React from 'react'
import PropTypes from 'prop-types'

import '../styles.css'

export default class NotesModule extends React.Component {

  static propTypes = {
    jobInfo: PropTypes.shape()
  }

  constructor(props) {
    super(props)
    this.state = {
      jobInfo: props.jobInfo
    }
  }

  render() {
    const note = this.state.jobInfo.modules.notes.value
    return (
      <div
        style={{ marginTop: 20, marginBottom: 30 }}
        className="vertical-container">
        <span
          className="field-label">
          Notes
        </span>
        <span
          style={{ marginTop: 4 }}
          className="field-label">
          {note && note !== '' ? note : '-'}
        </span>
      </div>
    )
  }
  
}



// WEBPACK FOOTER //
// ./src/schedule/common/modules/notes/NotesModule.js